import {
  AppProvider,
  Layout,
  SkeletonPage,
  SkeletonThumbnail,
  SkeletonBodyText
} from '@shopify/polaris';
import React from 'react';
import styled from 'styled-components';
import SkeletonTableLoading from './SkeletonTableLoading';
import { LoaderWrapper } from '@nile/banyan/src/Style/policy';
import { Loader } from '@nile/components';
// single line need to make component
const SingleLine = styled.div`
  width: ${(props) =>
    props.SingleLineWidth ? props.SingleLineWidth : '240px'};
  height: ${(props) =>
    props.SingleLineHeight ? props.SingleLineHeight : '15px'};
`;

const SkeletonLoading = (props) => {
  const {
    primaryAction = false,
    hideHeader = false,
    hideHeaderSub = false,
    hideTable = false,
    hideStepNav = false,
    showTableHeader = true,
    hideSecondaryHeader = false,
    showCardView = false,
    showPlainCardView = false,
    showPropertyCard = false,
    showInsighteCard = false,
    showConversationCard = false,
    sideNavRowCount = 4,
    headerSecondaryActionCount = 1,
    tableRow = 2,
    tableColumn = 4,
    cardCount = 6,
    secondaryHeaderDataCount = 3,
    primaryActionRowTwoCount = 3,
    fullWidth = false,
    propertyCardFullWidth = false,
    insightCardFullWidth = false,
    removeTableMargin = false,
    hideThumbnail = false,
    PlainCardRowCount = 2,
    showBox = false,
    cardViewCustomClassName = '',
    boxViewCustomClass = '',
    plainCardViewCustomClassName = '',
    noThumbnail,
    newLayout
  } = props;

  return (
    <div className="sops-header-loader skeleton-loader-wrapper">
      <AppProvider>
        <SkeletonPage
          primaryAction={primaryAction}
          //   secondaryActions={secondaryActions}
        >
          <div className="loader-wrap">
            {!hideHeader && (
              <div className="sk-header-wraper fx fx-sb pd-20-0">
                <div className="fx-center sk-left-sec">
                  {/* <div className="sops-thumnail-loader flick-animation"></div> */}
                  {noThumbnail ? (
                    <></>
                  ) : hideThumbnail ? (
                    <div className="sops-thumnail-loader flick-animation"></div>
                  ) : (
                    <SkeletonThumbnail size="medium" />
                  )}

                  <div>
                    <SingleLine
                      className="sops-single-line flick-animation m10"
                      SingleLineHeight="20px"
                    />
                    {!hideHeaderSub && (
                      <div className="fx fx-sb">
                        {Array.from(
                          { length: primaryActionRowTwoCount },
                          (_, i) => (
                            <div className="m12 mr-50">
                              <SingleLine
                                className="sops-single-line flick-animation"
                                SingleLineWidth="90px"
                              />
                            </div>
                          )
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="fx-center">
                  {Array.from(
                    { length: headerSecondaryActionCount },
                    (_, i) => (
                      <div className="sops-thumnail-loader flick-animation"></div>
                    )
                  )}
                </div>
              </div>
            )}
            {!hideSecondaryHeader && (
              <div className="sk-header-wraper fx fx-sb p8">
                <div className="fx-center sk-left-sec">
                  <div>
                    <div className="fx fx-sb">
                      {Array.from(
                        { length: secondaryHeaderDataCount },
                        (_, i) => (
                          <div className="m12 mr-20">
                            <SingleLine
                              className="sops-single-line flick-animation"
                              SingleLineWidth="90px"
                              SingleLineHeight="10px"
                            />
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>

                {/* <div className="fx-center">
                {Array.from({ length: headerSecondaryActionCount }, (_, i) => (
                  <div className="sops-thumnail-loader flick-animation"></div>
                ))}
              </div> */}
              </div>
            )}
            <div className="fx fw ">
              {/* Render step navigation  */}
              {!hideStepNav && (
                <div className="sk-step-nav-wrap">
                  {Array.from({ length: sideNavRowCount }, (_, i) => (
                    <div className="pb-8">
                      {Array.from({ length: 2 }, (_, i) => (
                        <SingleLine
                          className="sops-single-line flick-animation mb20"
                          SingleLineWidth="200px"
                        />
                      ))}
                    </div>
                  ))}
                </div>
              )}
              {!hideTable && (
                <div
                  className={`bg-white ${
                    removeTableMargin ? '' : 'sk-detail-table-wrap'
                  } ${hideStepNav ? 'fw' : 'sk-table-container-wrap'}`}
                >
                  <SkeletonTableLoading
                    tableRow={tableRow}
                    tableColumn={tableColumn}
                    tableHeader={showTableHeader}
                  />
                </div>
              )}

              {showCardView && (
                <div
                  className={`sk-step-nav-wrap
                  ${fullWidth ? '' : 'w50'} ${cardViewCustomClassName}`}
                >
                  {showBox && (
                    <>
                      <div className="fx">
                        <div className="card-container">
                          {Array.from({ length: cardCount }, (_, i) => (
                            <div className={`card-wrap ${boxViewCustomClass}`}>
                              <div className="h200 card-style">
                                <div className="flex-item-balloon flex-center f-16 text-medium">
                                  {/* <div class="loader">Loading...</div> */}
                                  <div className="fx actr jcenter w100 h-300 h170">
                                    <Loader />
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="card-style">
                        <SkeletonTableLoading
                          tableRow={2}
                          tableColumn={2}
                          tableHeader={false}
                        />
                      </div>
                    </>
                  )}
                </div>
              )}
              {showPlainCardView && (
                <div
                  className={`content-view sk-table-container-wrap p20 w50 ${plainCardViewCustomClassName}`}
                >
                  <div className="sk-table-container">
                    {Array.from({ length: PlainCardRowCount }, (_, i) => (
                      <div className={`${fullWidth ? '' : 'w50'}`}>
                        {Array.from({ length: 2 }, (_, i) => (
                          <div className="box-ch">
                            <SkeletonBodyText size="small" lines={2} />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {showConversationCard && (
                <div
                  className={
                    newLayout ? 'skeleton-loading section-0' : 'section-1 w50'
                  }
                ></div>
              )}
              {showPropertyCard && (
                <div
                  className={`content-view white-bg p20 ${
                    newLayout
                      ? 'skeleton-loading section-1'
                      : propertyCardFullWidth
                      ? 'fw'
                      : 'w30'
                  }`}
                >
                  <div className="sk-table-container">
                    {Array.from({ length: 2 }, (_, i) => (
                      <div className={`${fullWidth ? '' : 'w50'}`}>
                        {Array.from({ length: 2 }, (_, i) => (
                          <div className="py-8">
                            <SkeletonBodyText size="small" lines={2} />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {showInsighteCard && (
                <div
                  className={`content-view p20 ${
                    newLayout
                      ? 'skeleton-loading section-2'
                      : insightCardFullWidth
                      ? 'fw'
                      : 'w20'
                  }`}
                >
                  <div className="card-container g15">
                    {Array.from({ length: 2 }, (_, i) => (
                      <div className="fw">
                        <div className="card-style h160">
                          <div className="">
                            <SkeletonBodyText size="small" lines={2} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </SkeletonPage>
      </AppProvider>
    </div>
  );
};

export default SkeletonLoading;
